import { DataService } from './dataService'
export const vendorService = {

    addVendor: async (data) => {
        return DataService.post('/admin/add_vendor', data)
    },
    vendorCreate: async (data) => {
        return DataService.post('/admin/qbook/vendorCreate', data)
    },
    getVendor: async (data) => {
        return DataService.get('/admin/get_vendor', data)
    },
    updateVendor: async (data) => {
        return DataService.post('/admin/update_vendor', data)
    },
    deleteVendor: async (data) => {
        return DataService.post('/admin/delete_vendor', data)
    },
    getVendorDetails: async (data) => {
        return DataService.get('/admin/get_vendor_details', data)
    },
    update_vendor_status: async (data) => {
        return DataService.post('/admin/update_vendor_status', data)
    },
    
}
